export default ({ subject }) => subject && subject.permissions.likes.can_like;
